export function LoggableClassDecorator(params: {
  className: string;
}): ClassDecorator {
  return (target) => {
    for (const propertyName of Object.getOwnPropertyNames(target.prototype)) {
      const descriptor = Object.getOwnPropertyDescriptor(
        target.prototype,
        propertyName,
      );
      if (!descriptor) {
        continue;
      }
      const originalMethod = descriptor.value;
      const isMethod = originalMethod instanceof Function;
      if (!isMethod) {
        continue;
      }
      descriptor.value = function (...args: unknown[]) {
        const result = originalMethod.apply(this, args);

        const exitLog = () => {
          console.log(`${params.className}.${propertyName}`, args);
          // Logger.v({
          //   methodName: propertyName,
          //   args: args,
          //   result: result,
          //   target: target,
          //   className: params.className,
          // });
        };

        // work around to support async functions.
        if (
          result &&
          typeof result === 'object' &&
          typeof result.then === 'function'
        ) {
          const promise = result.then(exitLog);

          // we defer responsibility to the caller of the method to handle the error.
          // but we need to catch the error otherwise we will get an unhandled error.
          // notice we return the original result not the promise with the logging call.
          if (typeof promise.catch === 'function') {
            promise.catch((e: any) => e);
          }
        } else {
          exitLog();
        }
        return result;
      };
      Object.defineProperty(target.prototype, propertyName, descriptor);
    }
  };
}
